export default __webpack_public_path__ + "static/media/qrCode.10d2fd41.png";